import { FileText, FileSpreadsheet, FileImage, FileVideo, Mail, File } from "lucide-react";
import { IndianRupee, DollarSign, Euro, PoundSterling, Coins, Bitcoin } from 'lucide-react';

// export const API_DOMAIN = "https://uatmhlapi.metropolisindia.com/mhl_rni_api_uat/api/";     //RNI PRE PROD
// export const API_DOMAIN = "https://uatmhlapi.metropolisindia.com/mhl_api_uat/api/";     //UAT
// export const API_DOMAIN = "https://uatmhlapi.metropolisindia.com/mhl_dbp_uat/api/";     //UAT
// export const API_DOMAIN = "https://uatmhlapi.metropolisindia.com/pp_uat_metlink/api/";     //UAT2
// export const API_DOMAIN = "http://localhost:5168/api/";                              //Local
export const API_DOMAIN = "https://ppapi.metropolisindia.com/mhl_api/api/";          //PROD 

export const CONTAINERSIZEVALIDATION = 11;

export const API_HEADER = {
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  }
};


export const API_FILE_HEADER = {
  headers: {
    'Content-Type': 'multipart/form-data',
    'Access-Control-Allow-Origin': '*'
  }
};

export const COMPLAINT_TYPES = [
  { key: "FTR", value: "FTR" },
  { key: "SR-Complaint", value: "SR-Complaint" },
  { key: "SR-Request", value: "SR-Request" }
];


export const QUARTER_LISTS = [
  { key: "Q1(Apr-June)", value: "Q1" },
  { key: "Q2(Jul-Sep)", value: "Q2" },
  { key: "Q3(Oct-Dec)", value: "Q3" },
  { key: "Q4(Jan-March)", value: "Q4" }
];


export const TYPE_Of_CASE = [
  // { key: "Legal Case", value: "Legal Case" },
  { key: "Sensitive Case", value: "Sensitive Case" },
];


export const FileIcons = {
  docx: <FileText className="text-primary" size={20} />,
  doc: <FileText className="text-primary" size={20} />,
  xlsx: <FileSpreadsheet className="text-success" size={20} />,
  jpg: <FileImage className="text-warning" size={20} />,
  svg: <FileImage className="text-warning" size={20} />,
  png: <FileImage className="text-warning" size={20} />,
  jpeg: <FileImage className="text-warning" size={20} />,
  txt: <FileText className="text-secondary" size={20} />,
  pptx: <FileText className="text-danger" size={20} />,
  mov: <FileVideo className="text-info" size={20} />,
  email: <Mail className="text-orange" size={20} />,
  other: <File className="text-muted" size={20} />,
};

export const allowedTypes = [
  'application/pdf',
  'application/msword', // .doc
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/bmp',
  'image/svg+xml',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
  'message/rfc822', // .eml (email file)
  'video/mp4',
  'video/quicktime' // .mov
];

export function formatVisitDate(dateStr) {
  const date = new Date(dateStr);
  if (isNaN(date)) return '';

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12 || 12;

  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
}

// dd-MM-yyyy
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = ("0" + date.getDate()).slice(-2); // Add leading zero for single digit days
  const month = ("0" + (date.getMonth() + 1)).slice(-2); // Get month and add leading zero
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

// dd/MM/yyyy
export const formatDate2 = (dateString) => {
  const date = new Date(dateString);
  const day = ("0" + date.getDate()).slice(-2); // Add leading zero for single digit days
  const month = ("0" + (date.getMonth() + 1)).slice(-2); // Get month and add leading zero
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const CurrencyIcons = {
  USD: <DollarSign className="text-green-600" size={22} />,
  EUR: <Euro className="text-blue-600" size={22} />,
  GBP: <PoundSterling className="text-purple-600" size={22} />,
  INR: <IndianRupee className="text-orange-600" size={22} />,
  BTC: <Bitcoin className="text-yellow-500" size={22} />,
  OTHER: <Coins className="text-muted" size={22} />,
};
export const currencySymbols = {
  USD: <span style={{ marginRight: "1px" }}>$</span>,
  EUR: <span style={{ marginRight: "1px" }}>€</span>,
  INR: <span style={{ marginRight: "1px" }}>₹</span>,
  GHS: <span style={{ marginRight: "1px" }}>₵</span>,
  KES: <span style={{ marginRight: "1px" }}>KSh</span>,
  UGX: <span style={{ marginRight: "1px" }}>USh</span>,
  ZMW: <span style={{ marginRight: "1px" }}>ZK</span>,
  LKR: <span style={{ marginRight: "1px" }}>Rs</span>,
  MUR: <span style={{ marginRight: "1px" }}>₨</span>,
  TZS: <span style={{ marginRight: "1px" }}>TSh</span>,
};

export const MHL_DOS_Links = {
  EUR: "https://dos.metropolisindia.com/",
  USD: "https://dos.metropolisindia.com/",
  INR: "https://dos.metropolisindia.com/",
  GHS: "http://support.metropolisindia.com/ghana_edos/#/MetroEDOS",
  KES: "http://edos.metropoliskenya.com/#/MetroEDOS",
  UGX: "https://onedosuganda.metropolisindia.com/",
  ZMW: "http://support.metropolisindia.com/zambia_edos/#/MetroEDOS",
  LKR: "http://edos.metropolislanka.com/#/MetroEDOS",
  MUR: "https://dos.metropolisindia.com/",
  TZS: "https://onedostanzania.metropolisindia.com/",
};

export const HitechSettings = {
  baseUrl :  "https://partners.hitechlabsindia.in"
  // baseUrl :  "http://localhost:3000" 
}

export const formatAmount = (amount) => {
  if (amount >= 1e7) return (amount / 1e7).toFixed(2) + "Cr";
  if (amount >= 1e5) return (amount / 1e5).toFixed(2) + "L";
  return "₹" + amount.toLocaleString("en-IN");
};

export const LoadingMessage = () => {
  return (
    <span className="alert alert-warning" style={{ fontSize: "12px", width: '16rem', margin: 0, padding: '0.5rem', border: 0 }}>Loading... It might take up to 30 sec</span>
  )
}

// src/utils/dateUtils.js

export const formatUTCToIST = (utcDateStr) => {
  if (!utcDateStr) return "-";

  // Parse UTC date
  const utcDate = new Date(utcDateStr);

  // Convert to IST (UTC + 5 hours 30 minutes)
  const istDate = new Date(utcDate.getTime() + (5.5 * 60 * 60 * 1000));

  // Format: DD-MM-YYYY hh:mm A
  const day = String(istDate.getDate()).padStart(2, '0');
  const month = String(istDate.getMonth() + 1).padStart(2, '0');
  const year = istDate.getFullYear();

  let hours = istDate.getHours();
  const minutes = String(istDate.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;

  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
};
